import React, { useEffect, useState } from "react";
import { fetchPhotos, imageUrl } from "../lib/photosApi";
import Lightbox from "./lightbox";

const Photos = () => {
  const [photos, setPhotos] = useState([]);
  const [status, setStatus] = useState("loading"); // loading | ready | error
  const [lightboxIndex, setLightboxIndex] = useState(null);

  useEffect(() => {
    let cancelled = false;
    fetchPhotos()
      .then((data) => {
        if (cancelled) return;
        setPhotos(data);
        setStatus("ready");
      })
      .catch(() => {
        if (!cancelled) setStatus("error");
      });
    return () => {
      cancelled = true;
    };
  }, []);

  // Strip the page chrome/background so the photos are the whole screen.
  useEffect(() => {
    document.body.classList.add("photos-view");
    return () => document.body.classList.remove("photos-view");
  }, []);

  return (
    <main className="photos-page">
      {status === "error" && (
        <p className="photos-error">Sorry — couldn't load photos right now.</p>
      )}

      {status === "ready" && photos.length > 0 && (
        <section className="photo-grid" aria-label="Photos">
          {photos.map((photo, index) => {
            const ratio =
              photo.width && photo.height ? photo.width / photo.height : undefined;
            return (
              <button
                type="button"
                className="photo-card"
                key={photo.id}
                aria-label={`View ${photo.title || photo.category || "photo"}`}
                style={{
                  backgroundImage: `url(${photo.lqip})`,
                  aspectRatio: ratio,
                }}
                onClick={() => setLightboxIndex(index)}
              >
                <img
                  src={imageUrl(photo.grid_key)}
                  alt={photo.description || photo.title || ""}
                  width={photo.width || undefined}
                  height={photo.height || undefined}
                  loading="lazy"
                  decoding="async"
                  onLoad={(e) => e.currentTarget.classList.add("is-loaded")}
                />
              </button>
            );
          })}
        </section>
      )}

      {status === "ready" && photos.length === 0 && (
        <p className="photos-empty">No photos yet.</p>
      )}

      {lightboxIndex !== null && (
        <Lightbox
          photos={photos}
          index={lightboxIndex}
          onClose={() => setLightboxIndex(null)}
          onNavigate={setLightboxIndex}
        />
      )}
    </main>
  );
};

export default Photos;
